/**
 * Marcas dos provedores, em SVG embutido.
 *
 * Embutido e não arquivo: são duas imagens de 1 KB que apareceriam no primeiro
 * carregamento da única tela que alguém vê antes de entrar. Uma requisição a
 * mais ali custa mais do que o peso delas no bundle. Também evita depender de
 * `img-src` na CSP e de os arquivos serem copiados para o build do Vite — que
 * é exatamente o tipo de detalhe que quebra só em produção.
 *
 * As cores são fixas de propósito: são marcas registradas e não seguem a
 * paleta do produto. É a única exceção à regra de "nenhum literal fora de
 * tokens.css", e existe porque tingir o logo do Google de roxo seria errado.
 */

export function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <path fill="#4285F4" d="M45.1 24.5c0-1.6-.1-3.2-.4-4.7H24v9h11.8c-.5 2.7-2 5-4.4 6.6v5.5h7.1c4.2-3.8 6.6-9.5 6.6-16.4z" />
      <path fill="#34A853" d="M24 46c6 0 11-2 14.5-5.4l-7.1-5.5c-2 1.3-4.5 2.1-7.4 2.1-5.7 0-10.5-3.8-12.2-9H4.5v5.7C8 41 15.4 46 24 46z" />
      <path fill="#FBBC05" d="M11.8 28.2c-.4-1.3-.7-2.7-.7-4.2s.3-2.9.7-4.2V14H4.5C2.9 17 2 20.4 2 24s.9 7 2.5 10l7.3-5.8z" />
      <path fill="#EA4335" d="M24 11.4c3.2 0 6.1 1.1 8.4 3.3l6.3-6.3C34.9 4.9 30 3 24 3 15.4 3 8 8 4.5 14l7.3 5.8c1.7-5.2 6.5-9 12.2-9z" />
    </svg>
  );
}

export function MicrosoftIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="#F25022" d="M1 1h10.2v10.2H1z" />
      <path fill="#7FBA00" d="M12.8 1H23v10.2H12.8z" />
      <path fill="#00A4EF" d="M1 12.8h10.2V23H1z" />
      <path fill="#FFB900" d="M12.8 12.8H23V23H12.8z" />
    </svg>
  );
}
